<template>
  <div class="dynamic-by-source">
    <ul class="dynamic-by-source__header">
      <li class="dynamic-by-source__title">
        {{chartTitle}}
      </li>
      <li class="dynamic-by-source__tools" v-if="!dataEmpty">
        <el-button type="text" class="dynamic-by-source__tools-button" :disabled="saveChart" @click="onSave">
          <i class="material-icons color_grey">save</i>
        </el-button>
        <el-button type="text" class="dynamic-by-source__tools-button" v-if="!isEdit" @click="editChart">
          <i class="material-icons color_grey">edit</i>
        </el-button>
      </li>
    </ul>
    <el-card shadow="hover" class="dynamic-by-source__card" v-loading="pending">
      <dynamic-by-source-header :chart-name="name"/>

      <!--<chart-scale v-if="showChartScale" :chartScaleItems="chartScaleItems" @setScale="setScale"/>-->

      <template v-if="!dataEmpty">
        <dynamic-by-source-body
          :data="data"
          :chart-name="name"
          :save-chart="saveChart"
          :title="chartTitle"
          :chartScaleItems="chartScaleItems"
          :showChartScale="showChartScale"
          @onSavedChart="handleSaved"
          @onSaveChart="handleSave"
        />
      </template>

      <template v-else>
        {{$t('feed.analytics.dynamicBySource.noData')}}.
      </template>

    </el-card>
  </div>
</template>

<script>
// config
import sourceShortcuts from "../../../../../../../config/sourceShortcuts";

// mixins
import { analytics } from "../../../../../../../mixins/analytics";

import {
  TRUST_HOURLY, TRUST_DAILY
} from "../../../../../../../store/actions/analytics";

// components
import DynamicBySourceHeader from "./header/DynamicBySourceHeader";
import DynamicBySourceBody from "./body/DynamicBySourceBody";
import ChartScale from '../../../../../../../components/chartScale/ChartScale';

// vuex
import { mapGetters } from "vuex";

export default {
  name: "DynamicBySource",
  data() {
    return {
      name: "DynamicBySource",
      saveChart: false,
      chartScaleItems: {
        items: {
          days: {
            title: "Дни",
            labelMethod: "getLabelsByDays",
            dataMethod: "getDataByDays"
          },
          weak: {
            title: "Недели",
            labelMethod: "getLabelsByDays",
            dataMethod: "getDataByDays"
          },
          month: {
            title: "Месяцы",
            labelMethod: "getLabelsByDays",
            dataMethod: "getDataByDays"
          }
        },
        active: "days",
        activeMethod:"TRUST_DAILY"
      }
    };
  },
  computed: {
    ...mapGetters([
      "socialList",
    ]),
    sourceOf() {
      let sourceOf = [];
      let sourceShortcuts = this.$t('feed.analytics.dynamicBySource.shortcuts');

      if (Object.keys(this.data).length) {
        Object.entries(sourceShortcuts).forEach(shortcut => {
          if (this.socialList.includes(shortcut[0])) {
            if(this.data[shortcut[0]]) {
              sourceOf.push(shortcut[1]);
            }
          }
        });
      }

      return  sourceOf;
    },
    showChartScale() {
      return this.chartMethod === this.chartScaleItems.activeMethod;
    },
    chartTitle() {
      return  `${this.$t('feed.analytics.dynamicBySource.title')}: ${this.sourceOf.join(", ")}`;
    },
  },
  methods: {
    setScale(idx) {
      this.chartScaleItems.active = idx;
    },
    isRetro() {
        const retro_max = this.$store.getters.retro_max(this.$route.params.threadId)
        const retrospective = this.$store.getters.retrospective(this.$route.params.threadId)
        let end = new Date(retro_max);
        end.setDate(end.getDate() - 1);
        let condition = retro_max != null && new Date(retro_max) < new Date()
        return condition
        //return [`${condition ? retrospective : this.localPeriod[0].replace(" ", "T")}`, `${condition ? end.toJSON().split('T')[0] : this.localPeriod[1].split(' ')[0]} 23:59:59`.replace(" ", "T")];
    },
  },
  mounted() {
    if (!this.isRetro)
      this.$store.dispatch(TRUST_HOURLY, {chart: this.name, thread: this.$route.params.threadId})
    else
      this.$store.dispatch(TRUST_DAILY, {chart: this.name, thread: this.$route.params.threadId});
  },
  mixins: [
    analytics
  ],
  components: {
    DynamicBySourceHeader,
    DynamicBySourceBody,
    ChartScale
  }
};
</script>

<style>
  .dynamic-by-source {
    margin-bottom: 40px;
  }

  .dynamic-by-source__header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .dynamic-by-source__title {
    margin-bottom: 20px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #5E6D82;
  }

  .dynamic-by-source__tools .material-icons {
    font-size: 16px;
  }

  .dynamic-by-source__tools {
    margin-top: 4px;
    margin-right: 15px;
  }

  .dynamic-by-source__tools-button {
    padding: 0;
    color: #5e6d82;
  }

  .dynamic-by-source__tools-button:hover {
    color: #B3BCCC;
    font-size: 12px;
  }

  @media screen and (max-width: 480px) {
    .dynamic-by-source__card {
      overflow-x: auto;  }
    .dynamic-by-source__tools {
      display: none;
    }
  }
</style>
